import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Home } from 'lucide-react';

const CheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
  const planId = searchParams.get('plan') || '';
  const name = searchParams.get('name') || '';
  const email = searchParams.get('email') || '';
  const company = searchParams.get('company') || '';
  const phone = searchParams.get('phone') || '';
  const message = searchParams.get('message') || '';

  const isBuildPlan = ['basic', 'standard', 'premium'].includes(planId);

  useEffect(() => {
    // Auto-redirect to subscribe page after 3 seconds for build plans
    if (isBuildPlan) {
      const params = new URLSearchParams({ planId, name, email, company, phone, message });
      const timer = setTimeout(() => {
        window.location.href = `/subscribe?${params.toString()}`;
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isBuildPlan, planId, name, email, company, phone, message]);

  return (
    <div className="min-h-screen bg-white dark:bg-dark pt-24 pb-12 px-6">
      <div className="max-w-xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="w-20 h-20 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mx-auto mb-6">
            <Check className="text-green-600 dark:text-green-400" size={40} />
          </div>
          <h1 className="text-3xl font-bold text-primary dark:text-white mb-4">Payment Successful!</h1>
          <p className="text-gray-600 dark:text-gray-400 mb-2">
            Thank you for your purchase. We've received your payment and will begin working on your project right away.
          </p>
          <p className="text-gray-600 dark:text-gray-400 mb-8">
            You'll receive a confirmation email shortly with next steps.
          </p>

          {isBuildPlan && (
            <div className="bg-highlight/10 rounded-xl p-4 mb-8">
              <p className="text-highlight font-medium">
                Redirecting you to add monthly support in 3 seconds...
              </p>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white rounded-xl hover:bg-secondary transition-colors"
            >
              <Home size={18} />
              Back to Home
            </a>
            {isBuildPlan && (
              <a
                href={`/subscribe?planId=${planId}&name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}&company=${encodeURIComponent(company)}&phone=${encodeURIComponent(phone)}&message=${encodeURIComponent(message)}`}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-gray-200 dark:border-white/10 text-primary dark:text-white rounded-xl hover:bg-gray-50 dark:hover:bg-white/5 transition-colors"
              >
                Add Monthly Support
                <ArrowRight size={18} />
              </a>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
